export default {
  en: {
    price: '%{amount} %{currency}',
    priceWithCents: '%{amount} %{currency} and %{cents} cents',
    priceLeft: '%{currency} %{amount}',
    priceWithCentsLeft: '%{currency} %{amount}%{separator}%{cents}',
    rate: 'per %{rateText}',
    rateOnly: ' %{rateText}'
  },
  fr: {
    price: '%{amount} %{currency}',
    priceWithCents: '%{amount} %{currency} et %{cents} centimes',
    priceLeft: '%{currency} %{amount}',
    priceWithCentsLeft: '%{currency} %{amount}%{separator}%{cents}',
    rate: 'par %{rateText}',
    rateOnly: ' %{rateText}'
  }
};